module.exports = __webpack_public_path__ + "img/9788991963993.b7160065.jpg";